import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-32fc4b6a"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  key: 1,
  class: "TextLogicalReasoningQuestionContainer bothCenter wd100"
};
const _hoisted_2 = {
  class: "leftCenter question-content-container"
};
const _hoisted_3 = {
  class: "bothCenter logical-reasoning2DImg-continer"
};
const _hoisted_4 = ["src"];
const _hoisted_5 = ["src"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_TextAnalogyQuestion = _resolveComponent("TextAnalogyQuestion");
  return $options.isAnalogy ? (_openBlock(), _createBlock(_component_TextAnalogyQuestion, {
    key: 0,
    question: $props.question,
    interactive: false
  }, null, 8, ["question"])) : (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.parseImages($props.question.questionField), (img, imgIndex) => {
    return _openBlock(), _createElementBlock("img", {
      key: `img_${imgIndex}`,
      style: {
        "max-width": "100%"
      },
      src: img
    }, null, 8, _hoisted_4);
  }), 128)), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.parseImages($props.question.optionField), (img, imgIndex) => {
    return _openBlock(), _createElementBlock("img", {
      key: `img_op__${imgIndex}`,
      style: {
        "max-width": "100%"
      },
      src: img
    }, null, 8, _hoisted_5);
  }), 128))])])]));
}